import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  background: ${Colors.Neutral5};
  width: 100%;
  height: 100vh;
  overflow-x: auto;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: auto;
  z-index: 1001;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 165px;

  display: flex;
  flex-direction: column;
  align-items: center;
  ${Media.Tablet`
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 21px;
    height: unset;
    position: absolute;
  `}

  ${Media.Phone`
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 8px;
  `}
`

export const Title = styled.div`
  color: ${Colors.Neutral90};
  ${FontWeights.Medium};
  ${Typography.L};
  margin-top: 16px;
  margin-bottom: 64px;
  max-width: 832px;

  & > * {
    vertical-align: middle;
  }

  ${Media.Tablet`
    padding-top: 56px;
    margin-top: 36px;
    margin-bottom: 48px;
    margin-left: 24px;
    margin-right: 24px;
  `}

  ${Media.Phone`
    padding-top: 48px;
    margin-top: 16px;
    margin-bottom: 49px;
    margin-left: 16px;
    margin-right: 16px;
    ${Typography.M};
  `};
`

export const Logo = styled.span`
  margin: 0 5px;
  width: 41.333px;
  height: 41.333px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: ${Spacing['3XS']};
  & img {
    width: 32px;
    height: 32px;
  }
`
export const JobTitle = styled.span`
  color: ${Colors.Neutral50};
  ${FontWeights.Medium};
  ${Typography.L};
  align-items: center;
  ${Media.Phone`
    ${Typography.M};
  `}
`

export const Content = styled.div`
  max-width: 896px;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
`

export const GeneralFeedbackContainer = styled.div`
  background-color: ${Colors.White};
  padding: 32px;
  border-radius: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 86px;
  ${Media.Tablet`
    padding: 24px;
    gap: 64px;
  `}
  ${Media.Phone`
    flex-direction: column;
    padding: 16px;
    gap: 24px;
    margin-bottom: 32px;
  `}
`

export const GeneralFeedbackText = styled.div`
  ${Typography.Body};
  color: ${Colors.Neutral100};
  ${FontWeights.Medium};
`

export const GeneralFeedbackTitle = styled.h4`
  color: ${Colors.Neutral50};
`

export const GeneralFeedbackLeft = styled.div`
  flex: 1 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const GeneralFeedbackRight = styled.div`
  flex: 1 60%;
  display: flex;
  flex-direction: column;
  gap: 72px;

  ${Media.Phone`
    margin-top: 24px;
  `}
`

export const RejectionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const RejectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const RejectionTitle = styled.span`
  color: ${Colors.Neutral100};
  ${FontWeights.Medium};
  ${Typography.Body}
`

export const RejectionBody = styled.p`
  color: ${Colors.Neutral100};
  ${FontWeights.Regular};
  ${Typography.Body}
`

export const Paywall = styled.div`
  background: url(${require('builder/views/Interview/view/FeedbackView/assets/paywall-bg1.png')})
    center/cover;
  height: 243px;
  display: flex;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
`

export const PaywallText = styled.p`
  text-align: center;
  margin-top: 8px;
  margin-bottom: 16px;
`

export const Duration = styled.div`
  ${Typography.L};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
`
